import React from 'react';
import {noop} from 'lodash';

import {NewLabel} from '/component/base/NewLabel';
import {generateOnRecordPress} from '/component/partial/PeopleToContact/PeopleToContact.util';
import {PeopleToContactDataProvider} from '/component/partial/PeopleToContact/PeopleToContactDataProvider';
import LastOrderedDate from '/component/partial/report/LastOrderedDate';
import {PeopleRole} from '/component/partial/report/PeopleRole';
import PersonFullName from '/component/partial/report/PersonFullName';
import {NO_RX_ORDER} from '/enum/peopleToContact.enum';
import {
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
} from '/enum/records.enum';
import {FILTER_TYPES} from '/enum/tealium.enum';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface NoRXOrderProps {
  onItemPress: (item: {
    value: number;
    recordsName: string;
    filterName: string;
  }) => void;
  onShowProfile: () => void;
  parentScreenName: string;
  showFullReport: boolean;
  reportParams: any;
}

export const NoRXOrder: React.FC<NoRXOrderProps> = ({
  onItemPress = noop,
  onShowProfile = noop,
  parentScreenName = '',
  showFullReport = false,
  reportParams = null,
}) => {
  const {sortParam} = useRecordsSorting({
    recordsName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
  });

  const onViewMore = () => {
    onItemPress({
      value: 0,
      recordsName: REPORT_CLIENT_TO_CONTACT,
      filterName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
    });
  };

  // if the context has not been initialized yet, we take sorting from
  // the parent (default sorting)
  const defaultSorting = sortParam?.params
    ? [{...sortParam?.params}]
    : reportParams;

  return (
    <PeopleToContactDataProvider
      useMock
      screenParams={{type: NO_RX_ORDER}}
      clientMilestone={FILTER_TYPES.noRXOrder}
      onViewMore={onViewMore}
      reportParams={defaultSorting}
      reportName={REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER}
      parentScreenName={parentScreenName}
      dataRendererProps={{
        personNameComponent: PersonFullName,
        personRoleComponent: PeopleRole,
        personInfoComponent: LastOrderedDate,
        NewLabelComponent: NewLabel,
        onRecordPress: generateOnRecordPress({
          onShowProfile,
        }),
        showFullReport,
      }}
    />
  );
};
